export default __webpack_public_path__ + "static/media/Image2.44a7cb97.JPG";